import { PersisterConfigTable } from './PersisterConfigTable';
import { Box, Button, Typography } from '@mui/material';

const PersisterConfigs = () => {

    const UploadPersisterConfigButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"upload-persister-config"}
        >
            Upload Persister Config
        </Button>
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Persister Configs</Typography>
                </Box>
                <Box>
                    <UploadPersisterConfigButton />
                </Box>
            </Box>
            <PersisterConfigTable parent_id={undefined} />
        </div>
    )
}

export default PersisterConfigs;